export const addSocialMediaClickEventsToGTM = (
  action: string,
  platform: string
) => {
  dataLayer.push({
    Category: 'Social',
    Action: action,
    Label: `${platform}`, // i.e Twitter
    noninteraction: false,
    event: 'gaEvent',
  });
};
